<template>
    <div>
        <el-aside width="185px" class="layoutLeft">
            <div class="logo">SCRM</div>
            <el-menu
                :default-openeds="defaultOpeneds"
                :default-active="defaultActive"
                background-color="#2f3447"
                text-color="#fff"
                active-text-color="#fff"
                router
            >
                <el-menu-item index="/home">首页</el-menu-item>

                <div v-for="(item, index) in meauList" :key="index">
                    <el-menu-item
                        :index="`${item.web_route}`"
                        v-if="!item.childrenData"
                        :style="item.childrenData ? '' : 'font-size:14px'"
                        >{{ item.title }}</el-menu-item
                    >
                    <el-submenu :index="`${++index}`" v-else>
                        <template slot="title">{{ item.title }}</template>
                        <el-menu-item
                            :index="`${val.web_route}`"
                            v-for="(val, key) in item.childrenData"
                            :key="key"
                            >{{ val.title }}</el-menu-item
                        >
                    </el-submenu>
                </div>
            </el-menu>
        </el-aside>
    </div>
</template>

<script>
export default {
    data() {
        return {
            meauList: [],
            defaultOpeneds: [],
        }
    },
    computed: {
        defaultActive() {
            return this.$route.meta.isGuide
                ? this.$route.meta.guidePath
                : this.$route.path
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$EventBus.$on('aMsg', async () => {
                await this.getMeauList()
            })
        })
    },
    destroyed() {
        this.$EventBus.$off('aMsg')
    },
    methods: {
        //左侧列表
        async getMeauList() {
            await this.$api.getMeauList().then((res) => {
                this.meauList = res
            })
            const res = await this.$api.globalConfig({})
            this.$store.commit('globalConfig', res)
        },
    },
}
</script>
<style scoped lang="scss">
.layoutLeft {
    .logo {
        position: fixed;
        top: 0;
        left: 0;
        color: #fff;
        // text-align: center;
        padding: 15px 15px;
        box-sizing: border-box;
        letter-spacing: 3px;
        width: 185px;
        z-index: 1000;
        background: #2f3447;
    }
    padding-top: 58px;
    height: 100vh;
    box-sizing: border-box;
    background: #2f3447;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }
    &::-webkit-scrollbar-thumb {
        background: #2f3447;
    }
    &::-webkit-scrollbar-track {
        background: #2f3447;
    }
    .el-menu {
        border: none;
        .el-menu-item {
            font-size: 13px;
            &.is-active {
                background: #2d8cf0 !important;
            }
        }
    }
}
</style>
